'use client';

import Image from 'next/image';
import Link from 'next/link';
import { getCookie } from 'cookies-next';

import { useTranslations } from '@/hooks/useTranslations';
import { Button } from '@/components/ui';

import brandLogo from '../../../../public/images/brand-logo.png';
import notFoundImage from '../../../../public/images/not-found-image.png';

export default function NotFound() {
  const { translations } = useTranslations('not_found_page');
  const token = getCookie('accessToken');

  const notLoggedIn = !token || token === undefined || token === 'null';

  // Translation constants with fallbacks
  const title =
    translations?.title || "Oops! the page you were looking for doesn't exist.";
  const brokenLink =
    translations?.reasons?.broken_link ||
    'The link you clicked might be broken or outdated.';
  const wrongUrl =
    translations?.reasons?.wrong_url ||
    'You may have typed the URL incorrectly.';
  const movedDeleted =
    translations?.reasons?.moved_deleted ||
    'The page might have been moved or deleted.';
  const homepageText =
    translations?.homepage_text || "Don't worry, you can read a lot in our";
  const homepageLink = translations?.homepage_link || 'homepage';
  const createAccount = translations?.create_account || 'Create free account';
  const login = translations?.login || 'Login';
  const goHome = translations?.go_home || 'Go to home';

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="flex w-[766px] items-center justify-between">
        <div className="w-[310px]">
          <Image
            width={310}
            height={400}
            className="h-auto w-full"
            src={notFoundImage}
            alt="Not Found"
          />
        </div>
        <div className="w-[400px] space-y-3">
          <div className="pb-6">
            <Image width={120} height={80} src={brandLogo} alt="TenXer" />
          </div>

          <h1 className="text-3xl font-bold">{title}</h1>
          <ul className="ml-[23px] list-disc text-sm">
            <li>{brokenLink}</li>
            <li>{wrongUrl}</li>
            <li>{movedDeleted}</li>
          </ul>
          <p className="text-sm">
            {homepageText}{' '}
            <Link className="text-primary font-medium" href="/">
              {homepageLink}
            </Link>
          </p>

          <div className="pt-8">
            {notLoggedIn ? (
              <div className="flex gap-4">
                <Link href="/">
                  <Button className="rounded-full px-5" size="lg">
                    {createAccount}
                  </Button>
                </Link>
                <Link href="/">
                  <Button
                    className="rounded-full px-5"
                    size="lg"
                    variant="secondary"
                  >
                    {login}
                  </Button>
                </Link>
              </div>
            ) : (
              <div>
                <Link href="/">
                  <Button className="rounded-full px-5" size="lg">
                    {goHome}
                  </Button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
